import type { Locale } from 'date-fns';
import { format, isSameMonth, parseISO } from 'date-fns';
import { id } from 'date-fns/locale';

/**
 * Memformat rentang tanggal.
 * Jika bulan dan tahun sama, formatnya menjadi "d-d MMM yyyy".
 * Jika berbeda, formatnya menjadi "d MMM yyyy - d MMM yyyy".
 *
 * @param dateLeft Tanggal mulai (bisa string ISO atau objek Date).
 * @param dateRight Tanggal akhir (bisa string ISO atau objek Date).
 * @returns String rentang tanggal yang sudah diformat.
 */
export const formatDateRange = (
  dateLeft: string | Date,
  dateRight: string | Date
): string => {
  // Mengonversi input menjadi objek Date yang konsisten
  const start = typeof dateLeft === 'string' ? parseISO(dateLeft) : dateLeft;
  const end = typeof dateRight === 'string' ? parseISO(dateRight) : dateRight;

  // Mendefinisikan opsi locale dengan tipe yang sesuai
  const options: { locale: Locale } = { locale: id };

  // Memeriksa apakah bulan dan tahunnya sama
  if (isSameMonth(start, end)) {
    const startDay = format(start, 'd');
    const endFull = format(end, 'd MMM yyyy', options);
    return `${startDay}-${endFull}`;
  } else {
    const startFull = format(start, 'd MMM yyyy', options);
    const endFull = format(end, 'd MMM yyyy', options);
    return `${startFull} - ${endFull}`;
  }
};

export default formatDateRange;
